import {mapToFlatListWithKey, WithChildren} from '@hconnect/common/utils'
import {TFunction} from 'i18next'

export const getAllItemIds = <K extends keyof T, T extends WithChildren<T, K> & {id: string}>(
  childrenKey: K,
  data: T[]
): string[] => {
  return mapToFlatListWithKey(childrenKey, data ?? []).map((entry) => entry.id)
}

export const getCompletedMandatoryRcfasText = (t: TFunction) =>
  `${t('label.rcfas')} ${t('label.completed')}/${t('label.mandatory')}`
